export const ADDICTS_COLOR = 'rgb(163, 0, 0)';
export const ADDICTS_BACKGROUND_COLOR = 'rgba(163, 0, 0, .3)';
export const BOOKINGS_COLOR = 'rgb(255, 196, 0)';
export const BOOKINGS_BACKGROUND_COLOR = 'rgba(255, 196, 0, .3)';
export const EVENTS_COLOR = 'rgb(0, 140, 255)';
export const EVENTS_BACKGROUND_COLOR = 'rgba(0, 140, 255, .3)';
